module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 bg-lightest border-light cardHeight2 d-flex flex-column radius-normal"
  }, [_c('div', {}, [_c('div', {
    staticClass: "text-center darker font-weight-600 mt-4 fs-large"
  }, [_vm._v("\n            Download Reports\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dark text-center fs-small"
  }, [_vm._v("\n            " + _vm._s(_vm.subTitle) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 mb-2 d-flex justify-content-between flexGrow1 overflow-auto"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.reports), function(report) {
    return (report.active && _vm.accessPermissionFilter(report.allowedToAccess)) ? _c('div', {
      staticClass: "pointer d-flex flex-row col-sm-4 align-items-center position-relative",
      class: {
        'opacity-50 notAllowed': report.downloading
      },
      on: {
        "click": function($event) {
          return _vm.downloadReport(report)
        }
      }
    }, [(report.downloading) ? _c('div', {
      staticClass: "loadingHolder d-flex justify-content-center align-items-center"
    }, [_c('loader', {
      attrs: {
        "size": "small"
      }
    })], 1) : _c('div', [(report.fileType == 'xlsx') ? _c('div', [_c('svg', {
      staticClass: "downloadIcon small",
      staticStyle: {
        "enable-background": "new 0 0 490 490"
      },
      attrs: {
        "version": "1.1",
        "id": "Capa_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 490 490",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('path', {
      attrs: {
        "d": "M108.862,372.031l10.871-18.109c2.437-4.007,4.606-7.821,6.52-11.439l1.6-2.976h0.224l1.6,2.931l1.54,2.976\n                                c1.51,2.871,3.095,5.712,4.755,8.509l10.826,18.109h16.778l-24.135-38.879l22.64-36.487h-16.898l-10.049,16.838\n                                c-1.764,2.946-3.23,5.563-4.411,7.836l-1.376,2.602c-0.299,0.583-0.763,1.466-1.391,2.647h-0.209l-1.391-2.647l-1.376-2.662\n                                c-1.406-2.572-2.886-5.189-4.471-7.836l-10.049-16.778H93.4l22.969,36.487l-24.733,38.879H108.862z"
      }
    }), _vm._v(" "), _c('polygon', {
      attrs: {
        "points": "219.459,359.216 184.124,359.216 184.124,296.665 169.813,296.665 169.813,372.031 219.459,372.031 \t"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M255.408,361.204c-8.21,0-13.234-0.583-15.073-1.764c-1.839-1.181-2.766-4.396-2.766-9.66l-0.045-1.6h-13.922l0.06,2.751\n                                c0,8.763,1.944,14.58,5.817,17.451c3.888,2.871,11.754,4.307,23.612,4.307c13.174,0,21.698-1.466,25.571-4.381\n                                c3.858-2.931,5.802-9.406,5.802-19.41c0-8.135-1.66-13.488-4.95-16.075c-3.29-2.572-10.557-4.172-21.787-4.8\n                                c-9.495-0.508-15.088-1.256-16.778-2.213c-1.705-0.957-2.542-3.813-2.542-8.553c0-4.008,1.032-6.639,3.11-7.895\n                                c2.079-1.256,6.505-1.884,13.279-1.884c5.757,0,9.406,0.553,10.946,1.63c1.54,1.092,2.482,3.753,2.811,7.985\n                                c0,0.329,0.045,0.837,0.12,1.54h13.967v-2.871c0-7.806-1.974-13.04-5.907-15.731c-3.948-2.692-11.574-4.038-22.924-4.038\n                                c-11.963,0-19.948,1.466-23.941,4.396c-3.993,2.916-5.981,8.793-5.981,17.585c0,8.613,1.645,14.221,4.965,16.838\n                                c3.305,2.617,10.931,4.277,22.864,4.965l7.896,0.508c4.456,0.254,7.357,0.987,8.703,2.183c1.331,1.196,2.004,3.604,2.004,7.253\n                                c0,4.935-0.882,8.09-2.647,9.451C265.905,360.532,261.808,361.204,255.408,361.204z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M304.665,372.031l10.871-18.109c2.437-4.007,4.606-7.821,6.52-11.439l1.6-2.976h0.224l1.6,2.931l1.54,2.976\n                                c1.51,2.871,3.095,5.712,4.755,8.509l10.826,18.109h16.778l-24.12-38.879l22.64-36.487h-16.898l-10.049,16.838\n                                c-1.78,2.946-3.245,5.563-4.426,7.836l-1.376,2.602c-0.299,0.583-0.763,1.466-1.376,2.647h-0.224l-1.376-2.647l-1.391-2.662\n                                c-1.391-2.572-2.886-5.189-4.471-7.836l-10.049-16.778h-17.062l22.969,36.487l-24.733,38.879H304.665z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M77.788,0v265.111H42.189v139.615h0.001l35.59,35.591L77.788,490h370.023V102.422L345.388,0H77.788z M395.793,389.413\n                                H57.501v-108.99h338.292V389.413z M353.022,36.962l57.816,57.804h-57.816V36.962z"
      }
    })])])]) : _vm._e(), _vm._v(" "), (report.fileType == 'pdf') ? _c('div', [_c('svg', {
      staticClass: "downloadIcon small",
      staticStyle: {
        "enable-background": "new 0 0 490 490"
      },
      attrs: {
        "version": "1.1",
        "id": "Capa_1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "x": "0px",
        "y": "0px",
        "viewBox": "0 0 490 490",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('path', {
      attrs: {
        "d": "M77.788,0v265.111H42.189v139.615h0.001l35.59,35.591L77.788,490h370.023V102.422L345.388,0H77.788z M395.793,389.413\n                                H57.501v-108.99h338.292V389.413z M353.022,36.962l57.816,57.804h-57.816V36.962z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M172.819,296.665h-3.753h-30.371v75.366h14.303v-24.344h16.845l3.312-0.06c10.303,0,17.152-1.66,20.539-4.965\n                                c3.387-3.32,5.077-10.019,5.077-20.113c0-10.154-1.772-17.017-5.324-20.561C189.896,298.429,183.017,296.665,172.819,296.665z\n                                 M181.627,333.406c-1.75,1.495-5.862,2.243-12.337,2.243h-16.292v-26.946h17.728c6.109,0,9.892,0.763,11.342,2.288\n                                c1.458,1.525,2.183,5.473,2.183,11.843C184.251,328.396,183.376,331.91,181.627,333.406z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M244.94,296.665h-37.055v75.366h37.496c11.888,0,19.537-2.677,22.916-8.03c3.379-5.353,5.084-17.451,5.084-36.263\n                                c0-11.514-2.123-19.574-6.325-24.18C262.84,298.953,255.467,296.665,244.94,296.665z M255.841,355.268\n                                c-2.004,3.155-6.43,4.725-13.279,4.725h-20.374v-51.291h21.257c6.662,0,10.901,1.495,12.703,4.516\n                                c1.802,3.021,2.707,10.094,2.707,21.204C258.854,345.174,257.853,352.128,255.841,355.268z"
      }
    }), _vm._v(" "), _c('polygon', {
      attrs: {
        "points": "283.82,372.031 298.115,372.031 298.115,341.047 331.91,341.047 331.91,329.009 298.115,329.009 298.115,308.702\n                                333.735,308.702 333.735,296.665 283.82,296.665 \t"
      }
    })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ml-2 d-flex flex-column align-items-start"
    }, [_c('span', {
      staticClass: "fs-normal darker bold"
    }, [_vm._v(_vm._s(report.name))]), _vm._v(" "), (report.subName) ? _c('span', {
      staticClass: "fs-smaller dark"
    }, [_vm._v(_vm._s(report.subName))]) : _vm._e(), _vm._v(" "), (report.downloading) ? _c('span', {
      staticClass: "dark fs-smaller"
    }, [_vm._v("Downloading")]) : _vm._e(), _vm._v(" "), (report.downloadError) ? _c('span', {
      staticClass: "dark fs-smaller color-6"
    }, [_vm._v("Error downloading")]) : _vm._e()])]) : _vm._e()
  }), 0)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-a1425cbe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1425cbe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/cardDownload.vue
// module id = 1871
// module chunks = 0